/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type HomeMessageCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeMessageCardQuery = { __typename: 'Query', envelopes: Array<{ __typename: 'Envelope', id: string }> };


export const HomeMessageCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeMessageCard"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"operationServiceConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"StringValue","value":"content_marketing_messages","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<HomeMessageCardQuery, HomeMessageCardQueryVariables>;